import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

//import { Header } from './../../../Header/Header'
import { Header } from './../../../Header/V2/Header'
import { GoToTop } from './../../../Common/GoToTop'
import { SetDefaultWebTheme } from './../../../../utilities/BL/Settings'

import { CreditsText } from './../../../Common/Credits/CreditsText'
import { WEBPAGES } from '../../../../utilities/EL/WebPages'
import { TYPE_PROPOSITION_VALUE } from '../../../../utilities/EL/TypePropositionValue'
import { HELP_TYPE } from '../../../../utilities/EL/HelpType'
import { ROLES } from '../../../../utilities/EL/Roles'
import { BodyWithSideMenu } from '../../../Dashboard/BodyWithSideMenu'


const InstructorBase = ({ children, urlToGo, idHelp = null, page }) => {
    const navigate = useNavigate()

    const [theme, setTheme] = useState(null)
    const [isLoading, setIsLoading] = useState(true)

    const LoadPage = async () => {
        try {
            document.body.classList.add('BodyComplete')

            //Establecer el tema a la web
            const response = await SetDefaultWebTheme()
            
            if (response.success) {
                setTheme(response.data)
            }
        } catch (error) {
            
        } finally {
            setIsLoading(false)
        }
    }

    /**
     * Función para obtener la configuración, una vez que termine de cargarse el componente
     */
    useEffect(() => {
        LoadPage()
    }, []) // El array vacío [] asegura que useEffect se ejecute solo una vez, al montar


    return (
        !isLoading && (
            <>
                {/* AJUSTAR LA PAGE PARA QUE SE MUESTRE LA AYUDA. PODRÍA VENIR POR PARÁMETRO */}
                <BodyWithSideMenu page={page} theme={theme} propositionValue={TYPE_PROPOSITION_VALUE.INSTRUCTOR} idHelp={idHelp} role={ROLES.INSTRUCTOR}>
                    {/* <Header theme={theme} idHelp={idHelp}  /> */}
                    <Header theme={theme} setTheme={setTheme} propositionValue={TYPE_PROPOSITION_VALUE.INSTRUCTOR} idHelp={idHelp} />

                    <main className='InstructorBase__Main Container-FullHeight'>
                        {urlToGo && (
                            <div className='container InstructorBase__Main__Return'>
                                <button type="button" onClick={() => navigate(urlToGo)} className='Btn__Ztudia--Link InstructorBase__Main__Return__Btn'>
                                    <i className="bi bi-caret-left-fill"></i>
                                </button>
                            </div>
                        )}

                        {children}
                    </main>

                    {/* <footer className="container InstructorBase__Footer Instructor__SpaceUp">
                        <p className='Instructor__Text--Center'><CreditsText /></p>
                        <div className='d-flex flex-wrap justify-content-center'>
                            <p style={{textAlign: 'center', cursor: 'pointer', textDecoration: 'underline', fontSize: '12px', marginBottom: '12px' }} onClick={() => navigate('/legals/privacy')}>Aviso de privacidad</p>
                            <p style={{textAlign: 'center', cursor: 'pointer', textDecoration: 'underline', fontSize: '12px', marginBottom: '12px', marginLeft: '16px' }} onClick={() => navigate('/contact')}>Contacto</p>
                        </div>
                    </footer> */}

                    {/* <GoToTop /> */}
                </BodyWithSideMenu>
            </>
        )
    )
}

export { InstructorBase };